import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ConspiracySection } from './components/ConspiracySection';
import { BenefitsSection } from './components/BenefitsSection';
import { IngredientsSection } from './components/IngredientsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <Hero data-id="element-3" />
        <ConspiracySection data-id="element-4" />
        <BenefitsSection data-id="element-5" />
        <IngredientsSection data-id="element-6" />
        <TestimonialsSection data-id="element-7" />
        <FAQSection data-id="element-8" />
        <PricingSection data-id="element-9" />
        <GuaranteeSection data-id="element-10" />
        <CTASection data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}